import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../../Services/Api/ApiServices";

export const GetAllSC_ST_AI_Field = createAsyncThunk(
  "SC_ST_AI_Field/GetAllSC_ST_AI_Field",
  async (parameters, { rejectWithValue }) => {
    try {
    
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/SC_ST_AI_Field/GetAllSC_ST_AI_Field",
        parameters
      );

      const data = response.data.result; // Assuming response has a "data" field
      console.log(data, "app");
      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);



const SC_ST_AI_Field = createSlice({
  name: "SC_ST_AI_Field",
  initialState: {
    //------------- GetSC_ST_AI_Field ---------------------
    SC_ST_AI_FieldList: [],
    loadingSC_ST_AI_FieldList: false,
    errorSC_ST_AI_FieldList: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetAllSC_ST_AI_Field.pending, (state, action) => {
        state.loadingSC_ST_AI_FieldList = true;
        state.SC_ST_AI_FieldList = action.payload;
        state.errorSC_ST_AI_FieldList = null;
      })
      .addCase(GetAllSC_ST_AI_Field.fulfilled, (state, action) => {
        state.loadingSC_ST_AI_FieldList = false;
        state.SC_ST_AI_FieldList = action.payload;
      })
      .addCase(GetAllSC_ST_AI_Field.rejected, (state, action) => {
        state.loadingSC_ST_AI_FieldList = false;
        state.SC_ST_AI_FieldList = action.payload;
      });
  },
});

export default SC_ST_AI_Field.reducer;
